import React from "react";
import { Accordion, AccordionProps } from "../accordion";
import { NavMenuItem, NavSubMenuItem } from "../types";
import { CSS_CLASSES as NAV_MENU_CSS_CLASSES } from "./nav-menu-css-classes";
import { VerticalMainNavMenuItem } from "./vertical-main-nav-menu-item";

export interface VerticalMainNavMenuProps {
  color?: "interactive" | "primary";
  menuItems: NavMenuItem[];
  activeMenuItemIndex: number;
  onMenuItemActivate: AccordionProps["onActivate"];
  onSubMenuItemActive: (subMenuItem: NavSubMenuItem) => void;
}

export const VerticalMainNavMenu = ({
  color = "interactive",
  menuItems,
  activeMenuItemIndex,
  onMenuItemActivate,
  onSubMenuItemActive,
}: VerticalMainNavMenuProps) => {
  return (
    <Accordion
      color={color}
      separatorClassName="mx-4"
      hideFirstSeparator
      activeIndex={[activeMenuItemIndex]}
      onActivate={onMenuItemActivate}
      className={NAV_MENU_CSS_CLASSES.VERTICAL_MAIN_NAV_MENU}
    >
      {menuItems.map((item) => {
        const {
          id,
          label,
          onClick,
          href,
          className,
          active,
          navMenuItemComponent,
          navMenuItemComponentProps,
          subMenuItems = [],
          ...restItemProperties
        } = item;

        return (
          <VerticalMainNavMenuItem
            key={id}
            id={id}
            label={label}
            href={href}
            className={className}
            navMenuItemComponent={navMenuItemComponent}
            navMenuItemComponentProps={navMenuItemComponentProps}
            subMenuItems={subMenuItems}
            color={color}
            onSubMenuItemActive={onSubMenuItemActive}
            restItemProperties={restItemProperties}
          />
        );
      })}
    </Accordion>
  );
};
